import { Text } from "react-native-paper";
import { useAppTheme } from "../../../../useAppTheme";
import Box from "../../../Box";
import { PreTestCard } from "./PreTestCard";
import { PreTestTable } from "./PreTestTable";

export type PartIntroSection = {
	section: string;
	itemTypes: string[];
	timeAllowed: string;
};

export type PartIntroContent = {
	title: string;
	meta?: string;
	bullets?: string[];
	tableTitle?: string;
	sections: PartIntroSection[];
};

type Props = PartIntroContent;

const PartIntro = ({
	title,
	meta,
	bullets = [],
	tableTitle,
	sections,
}: Props) => {
	const theme = useAppTheme();

	return (
		<PreTestCard>
			<Box gap={8}>
				<Text variant="titleLarge">{title}</Text>
				{meta ? (
					<Text variant="bodyLarge" style={{ color: theme.colors.secondary }}>
						{meta}
					</Text>
				) : null}
			</Box>

			{bullets.length > 0 ? (
				<Box gap={8}>
					{bullets.map((bullet, index) => (
						<Box
							// biome-ignore lint/suspicious/noArrayIndexKey: static intro bullets
							key={index}
							flexDirection="row"
							gap={8}
							alignItems="flex-start"
						>
							<Text variant="bodyLarge">{"•"}</Text>
							<Text variant="bodyLarge" style={{ flex: 1 }}>
								{bullet}
							</Text>
						</Box>
					))}
				</Box>
			) : null}

			<PreTestTable
				caption={tableTitle}
				columns={[
					{ label: "Section", flex: 1 },
					{ label: "Item Type", flex: 1.6 },
					{ label: "Time allowed", flex: 1 },
				]}
				rows={sections.map((section) => [
					section.section,
					<Box gap={10} key={`${section.section}-items`}>
						{section.itemTypes.map((itemType) => (
							<Box
								key={itemType}
								flexDirection="row"
								gap={8}
								alignItems="flex-start"
							>
								<Text variant="bodyMedium">{"•"}</Text>
								<Text variant="bodyMedium">{itemType}</Text>
							</Box>
						))}
					</Box>,
					section.timeAllowed,
				])}
			/>
		</PreTestCard>
	);
};

export default PartIntro;
